<template>
  <a-spin :spinning="!this.chartData">
    <h3>GDP growth rate VS population ages 65 and above rate in 2019 </h3>
    <div id = "gdp-body">
      <svg id="gdp-groth-chart"></svg>
      <svg id = "label" width = "500" height = "100">
        <line class="regression" x1="20" y1 ="20" x2="50" y2="20"></line>
        <text x="52" y="23" font-size="0.9em">Linear regression of GDP growth rate and percentage of total population</text>
      </svg>
    </div>   
  </a-spin>
</template>
<script>
import * as d3 from "d3";
// import * as d3_regression from "d3-regression";
import axios from "axios";
export default {
    name: "GDPgrouthChart",
    data: function(){
        return{
            chartData: null,
        };
    },
    
    mounted(){
      // console.log('mounted');
      const API = this.$store.state.API;
      if (!this.$store.state.GdpGData) {
      axios.get(`${API}affect/gdpGrouth.json`).then(result => {
        this.chartData = result.data;  
        // console.log('chartData set from file');
        // console.log('chartData contains', this.chartData.length, 'rows');
        this.$store.commit('GdpGData', result.data);
        this.makeGGChart();
        })
    } else {
      // console.log(this.chartData);
      this.chartData = this.$store.state.GdpGData;
      // console.log('chartData set from store');
      // console.log('chartData contains', this.chartData.length, 'rows');
      this.makeGGChart();
    }},
    methods:{
        makeGGChart(){
            var margin = { top: 50, left: 35, bottom: 50, right: 40 };
            var width = 500 - margin.left - margin.right;
            var height = 500 - margin.top - margin.bottom; 
            var x = d3.scaleLinear().range([0, width]);
            var y = d3.scaleLinear().range([height, 0]);
            var svg = d3.select("#gdp-groth-chart")
              .attr('width', width + margin.left + margin.right)
              .attr('height', height + margin.top + margin.bottom)
              .append('g').attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');
          const gdpData = JSON.parse(JSON.stringify(this.chartData));
          // console.log(gdpData);
          var div = d3.select("#gdp-body")
            .append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);
          x.domain(
            d3.extent(gdpData, function(d){
              return d.above65r;
            })
          ).nice();
          y.domain([d3.min(gdpData,function(d){
            return d.gdpg;
          }), d3.max(gdpData, function(d){
            return d.gdpg;
          })
          ]).nice();
          var lg = calcLinear(gdpData, "above65r", "gdpg", d3.min(gdpData, function(d){ 
            return d.above65r}), 
            d3.min(gdpData, function(d){ return d.above65r}));         
          svg.selectAll('circle')
          .data(gdpData)
          .enter()
          .append('circle')
          .attr('r', 3)
          .attr('cx', function(d){return x(d.above65r); })
          .attr('cy', function(d){return y(d.gdpg); })
          .attr('class', function(d){return d.countryName})
          .attr('fill', function(d){
            if(d.countryName == "Japan" || d.countryName == "Italy" || d.countryName == "Finland" || d.countryName == "France" || d.countryName == "Spain"){
              return "#67000d"
            }else if(d.countryName == "United Kingdom" || d.countryName == "Canada" || d.countryName == "United States" || d.countryName == "Australia" || d.countryName == "Iceland"){
              return "#a50f15"
            }
            else if(d.countryName == "China" || d.countryName == "Chile"){
              return "#fb6a4a"
            }
            else if(d.countryName == "Turkey"){
              return "#fc9272"
            }
            else if(d.countryName == "Mexico"){
              return "#fcbba1"
            }
            else{
              return "#a2a2d0"
            }
          })
          .attr('fill-opacity', 0.6)
          .on('mouseover', function(d){
            d3.select(this).transition()
            .duration('100')
            .attr('r', 7);
            div.transition()
          .duration(100)
          .style("opacity", 1);
          div.append("text")
          .text("hello")
           div.html("Country: "+this.__data__.countryName +",     GDP grouth rate: "+ this.__data__.gdpg + "%,    Percentage of total population age 65 and above: " + this.__data__.above65r + "%")
               .style("left", (d.screenX-200)+"px")
               .style("top", (d.screenY-200)+"px");
               // console.log(this.__data__)
               // console.log(d.screenX+10)
               // console.log(d.screenY-15)
          })
          .on('mouseout', function(){
            // console.log(d.__data__)
            d3.select(this).transition()
            .duration('200')
            .attr('r', 3);
            // makes div disappear
          div.transition()
          .duration('200')
          .style("opacity", 0);
          });
          
          svg.append('line')
          .attr('class', 'regression')
          .attr('x1', x(lg.ptA.x))
          .attr('y1', y(lg.ptA.y))
          .attr('x2', x(lg.ptB.x))
          .attr('y2', y(lg.ptB.y));
          // console.log(x(lg.ptB.x))
          // console.log(y(lg.ptB.y))

          var xAxis = d3.axisBottom().scale(x).ticks(5,'2f')

          svg.append('g')
          .attr('transform', 'translate(0,' + height/2 + ')')
          .attr('class', 'xaxis')
          .call(xAxis);
          var yAxis = d3.axisLeft()
        .scale(y)
        .ticks(7, '.1f');  //ticks with format
        svg.append('g')
      .attr('class', 'yaxis')
      .call(yAxis);
      svg.append('text')
      .attr('x', -height/2 - 50)
      .attr('y', -margin.left*0.6)
      .attr('transform', 'rotate(-90)')
      .attr('class', 'label')
      .append('tspan').text('GDP growth rate (% of last year)')
      .style('baseline-shift', 'super')
      .style('font-size', '0.7em');
      svg.append('text')
      .attr('transform', 'translate('+(width-80)+','+(height/2+40)+')')
      .text('ages 65 and above (% of total population)')
      .style('text-anchor', 'middle')
      .style('font-size', '0.7em');
      function calcLinear(data, x, y, minX, minY){
              /////////
              //SLOPE//
              /////////

      // Let n = the number of data points
      var n = data.length;

      // Get just the points
      var pts = [];
      data.forEach(function(d){
        var obj = {};
        obj.x = d[x];
        obj.y = d[y];
        obj.mult = obj.x*obj.y;
        pts.push(obj);
      });
      // Let a equal n times the summation of all x-values multiplied by their corresponding y-values
      // Let b equal the sum of all x-values times the sum of all y-values
      // Let c equal n times the sum of all squared x-values
      // Let d equal the squared sum of all x-values
      var sum = 0;
      var xSum = 0;
      var ySum = 0;
      var sumSq = 0;
      pts.forEach(function(pt){
        if(!Number.isNaN(pt.mult)){
        sum = sum + pt.mult;
        xSum = xSum + pt.x;
        ySum = ySum + pt.y;
        sumSq = sumSq + (pt.x * pt.x);
        }
        // // console.log(pt.mult)
        // // console.log(i)

      });
      // console.log("n "+ n)
      var a = sum * n;
      var b = xSum * ySum;
      var c = sumSq * n;
      var d = xSum * xSum;
      // console.log("sum "+ sum)

      // Plug the values that you calculated for a, b, c, and d into the following equation to calculate the slope
      // slope = m = (a - b) / (c - d)
      var m = (a - b) / (c - d);

      /////////////
      //INTERCEPT//
      /////////////

      // Let e equal the sum of all y-values
      var e = ySum;

      // Let f equal the slope times the sum of all x-values
      var f = m * xSum;
// Plug the values you have calculated for e and f into the following equation for the y-intercept
      // y-intercept = b = (e - f) / n
      b = (e - f) / n;
      

			// Print the equation below the chart
			// document.getElementsByClassName("equation")[0].innerHTML = "y = " + m + "x + " + b;
			// document.getElementsByClassName("equation")[1].innerHTML = "x = ( y - " + b + " ) / " + m;

      // return an object of two points
      // each point is an object with an x and y coordinate
      return {
        ptA : {
          x: minX,
          y: m * minX + b
        },
        ptB : {
          y: minY,
          x: (minY - b) / m
        }
      }}
        }
    }}
</script>
<style scoped>
>>> .regression {
stroke-width: 2px;
stroke: steelblue;
stroke-dasharray: 10,5;
		}
/* >>> div.tooltip {
     position: absolute;
     text-align: center;
     padding: .2rem;
     background: #313639;
     color: #f9f9f9;
     border: 0px;
     border-radius: 8px;
     pointer-events: none;
     font-size: .7rem;
} */
>>> div.tooltip {
  position: absolute;
  text-align: center;
  pointer-events: none;

  line-height: 1;
  font-weight: bold;
  padding: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 2px;
}
</style>